import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import find from 'lodash/find';
import {
    SHIPPING_MESSAGES_PICKUP_MESSAGE,
    SHIPPING_GROUP_TYPE_BOPIS,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ShippingAddressDetails from '../ShippingAddressDetails/ShippingAddressDetails';
import ProductDetailsList from '../ProductDetailsList/ProductDetailsList';
import PickupPersonInfo from '../PickupPersonInfo/PickupPersonInfo';
import SilverAdditionalDeliveryMessage from '../SilverAdditionalDeliveryMessage/SilverAdditionalDeliveryMessage';
import StoreDetails from '../StoreDetails/StoreDetails';
import * as styles from './ShippingGroupDetails.css';

const cx = classNames.bind(styles);
const shippingGroupTitle = {
    HOME: 'Ship to Home',
    BOPIS: 'Same Day Pickup',
    STORE: 'Ship to Store',
    SHIPPING: 'Shipping',
};
function ShippingGroupDetails({
    shippingGroupDetails,
    orderAdjustments,
    orderGiftRegistries,
    bopisHolidayMessage,
    pickupDateMessage,
}) {
    const isApplianceItem = find(shippingGroupDetails.bagItems, {
        product: { type: 'LARGEAPPLIANCE' },
    });
    return (
        <div
            key={shippingGroupDetails.type}
            className=""
            data-automation-id="at-shipping-group-details"
        >
            <div className={styles.row}>
                <div className={`${cx('shipHeader')} ${dt(['px-6', 'pt-6', 'pb-2'])}`}>
                    <span
                        data-automation-id="at-shipping-group-title"
                        className={dt(['font-open-sans-bold', 'text-xlarge'])}
                    >
                        {shippingGroupTitle[`${shippingGroupDetails.type}`]}
                    </span>
                </div>
                <div
                    data-automation-id="at-shipping-address-block"
                    className={dt(['px-6', 'pb-6'])}
                >
                    <div className={`${cx('col6')} ${dt(['!p-0'])}`}>
                        {shippingGroupDetails.store && shippingGroupDetails.store.id ? (
                            <StoreDetails storeId={shippingGroupDetails.store.id} />
                        ) : (
                            <ShippingAddressDetails address={shippingGroupDetails.address} />
                        )}
                    </div>
                    <div
                        className={`${styles.deliveryDateBlk} ${cx('col6')} ${dt([
                            'align-top',
                            'text-right',
                            '!p-0',
                        ])}`}
                        data-automation-id="at-delivery-date-block"
                    >
                        {shippingGroupDetails.type === SHIPPING_GROUP_TYPE_BOPIS ? (
                            <div>
                                <div
                                    data-automation-id="at-pickup-today"
                                    className={dt(['text-normal', 'font-open-sans-bold', 'pb-2'])}
                                >
                                    Pickup {pickupDateMessage}
                                </div>
                                <div
                                    data-automation-id="at-pickup-message"
                                    className={dt(['text-small', 'text-gray-60'])}
                                >
                                    {bopisHolidayMessage || SHIPPING_MESSAGES_PICKUP_MESSAGE}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                    {shippingGroupDetails.pickupContact ? (
                        <div className={cx('pickupPersonInfo')}>
                            <PickupPersonInfo
                                pickupPersonInfo={shippingGroupDetails.pickupContact}
                            />
                        </div>
                    ) : (
                        shippingGroupDetails.pickup &&
                        shippingGroupDetails.pickup.alternatePerson && (
                            <div className={dt(['smMd:pl-1'])}>
                                <PickupPersonInfo pickupPersonInfo={shippingGroupDetails.pickup} />
                            </div>
                        )
                    )}
                </div>
                {isApplianceItem ? (
                    <SilverAdditionalDeliveryMessage shippingGroupDetails={shippingGroupDetails} />
                ) : (
                    ''
                )}
                <ProductDetailsList
                    shippingGroupDetails={shippingGroupDetails}
                    orderAdjustments={orderAdjustments}
                    orderGiftRegistries={orderGiftRegistries}
                />
            </div>
        </div>
    );
}

ShippingGroupDetails.propTypes = {
    shippingGroupDetails: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string])
    ).isRequired,
    orderAdjustments: PropTypes.arrayOf(PropTypes.object).isRequired,
    orderGiftRegistries: PropTypes.objectOf(PropTypes.object).isRequired,
    bopisHolidayMessage: PropTypes.string,
    pickupDateMessage: PropTypes.string,
};

ShippingGroupDetails.defaultProps = {
    bopisHolidayMessage: '',
    pickupDateMessage: 'Today',
};

export default ShippingGroupDetails;
